import { render, staticRenderFns } from "./teachersAndStudentsMoreList.vue?vue&type=template&id=05400628&scoped=true"
import script from "./teachersAndStudentsMoreList.vue?vue&type=script&lang=js"
export * from "./teachersAndStudentsMoreList.vue?vue&type=script&lang=js"
import style0 from "./teachersAndStudentsMoreList.vue?vue&type=style&index=0&id=05400628&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05400628",
  null
  
)

export default component.exports